import React from "react"
import {
    CTable,
    CTableRow,
    CTableHeaderCell,
    CTableBody,
    CTableDataCell,
    CSpinner,
    CRow,
    CCol,
    CFormInput,
    CFormLabel} from '@coreui/react'
import {
    cilCloudDownload, cilSearch
} from '@coreui/icons'
import AppButton from 'src/components/AppButton'
import ServerConnector from 'src/ServerConnector'
import PageHeader from "src/components/PageHeader"
import DatePicker from 'react-date-picker';
import { getDBDate } from "src/util/DateUtil"


export default class SummaryReport extends React.Component {
    constructor(props) {
        super(props);

        var today = new Date();

        this.state = {
            spinner: false,
            fromDate: new Date(today.getFullYear()-1, today.getMonth(), today.getDate()),
            toDate: today,
            reportData: {}
        };
    }
    componentDidMount() {
        this.loaddata('REPORT')
    }

    loaddata(format) {

        this.setState({
            spinner: true
        });

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_SUMMARY_REPORT",
            "format": format,
            "from_date": getDBDate(this.state.fromDate),
            "to_date": getDBDate(this.state.toDate),
        }

        connector.postData(dataMap, (data) => { // success

            if (format == "REPORT") {

                this.setState({
                    spinner: false,
                    reportData: data.data
                });
            }
            else {
                this.setState({
                    spinner: false,
                });

                window.open(data.data[0].file_path, '_blank', 'noreferrer');
            }
        }, (err_cd, msg, data) => { // failure

            if (format == "REPORT") {
                this.setState({
                    spinner: false,
                    reportData: {}
                });
            }
            else {
                this.setState({
                    spinner: false,
                });
            }
        })
    }

    handleExportXls() {

        this.loaddata('XLS');
    }

    updateInput(key, value) {

        this.setState({
            [key]: value
        });
    }

    render() {
        return (
            <>
                <PageHeader page_name={this.props.page_name} >
                    <AppButton
                        color="primary"
                        name="Export To XLS"
                        icon={cilCloudDownload}
                        isLoading={false}
                        onClick={() => this.handleExportXls()} />
                </PageHeader>
                <CRow>
                    <CCol md="4">
                        <CFormLabel style={{marginRight: 5, fontWeight: 'bold'}}>Start Date:</CFormLabel>
                        <DatePicker 
                            onChange={(value) => this.updateInput("fromDate", value)} 
                            value={this.state.fromDate}
                            format="dd/MM/y"
                            dayPlaceholder="dd"
                            monthPlaceholder="MM"
                            yearPlaceholder="yyyy"
                            showLeadingZeros={true}
                            clearIcon={null}
                            maxDate={new Date()} />
                    </CCol>
                    <CCol md="4">
                    <CFormLabel style={{marginRight: 5, fontWeight: 'bold'}}>End Date:</CFormLabel>
                        <DatePicker 
                            onChange={(value) => this.updateInput("toDate", value)} 
                            value={this.state.toDate}
                            format="dd/MM/y"
                            dayPlaceholder="dd"
                            monthPlaceholder="MM"
                            yearPlaceholder="yyyy"
                            showLeadingZeros={true}
                            clearIcon={null}
                            maxDate={new Date()} />
                    </CCol>
                    <CCol md="4">
                        <AppButton
                            color="primary"
                            name="Search"
                            icon={cilSearch}
                            isLoading={false}
                            onClick={() => { this.loaddata('REPORT'); }} />
                    </CCol>
                </CRow>
                {
                    this.state.spinner ?
                        <div className="spinnerHolder">
                            <CSpinner color="primary" />
                        </div>
                        : null
                }
                <CTable style={{marginTop: 24}}>
                    <CTableBody>
                        <CTableRow>
                            <CTableHeaderCell style={{width: '50%'}} scope="col">Total Doubts raised</CTableHeaderCell>
                            <CTableDataCell style={{width: '50%'}} scope="col">
                                {this.state.reportData.total_doubts ? this.state.reportData.total_doubts : "0"}
                            </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                            <CTableHeaderCell scope="col">Total doubts cleared</CTableHeaderCell>
                            <CTableDataCell scope="col">
                                {this.state.reportData.total_cleared ? this.state.reportData.total_cleared : "0"}
                            </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                            <CTableHeaderCell scope="col">Total accepted doubts</CTableHeaderCell>
                            <CTableDataCell scope="col">
                                {this.state.reportData.total_accepted ? this.state.reportData.total_accepted : "0"}
                            </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                            <CTableHeaderCell scope="col">Total rejected doubts</CTableHeaderCell>
                            <CTableDataCell scope="col">
                                {this.state.reportData.total_rejected ? this.state.reportData.total_rejected : "0"}
                            </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                            <CTableHeaderCell scope="col">Total pending status (yet to be rated)</CTableHeaderCell>
                            <CTableDataCell scope="col">
                                {this.state.reportData.not_rated ? this.state.reportData.not_rated : "0"}
                            </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                            <CTableHeaderCell scope="col">Total Locked questions</CTableHeaderCell>
                            <CTableDataCell scope="col">
                                {this.state.reportData.total_blocked ? this.state.reportData.total_blocked : "0"}
                            </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                            <CTableHeaderCell scope="col">No of Coordinators created</CTableHeaderCell>
                            <CTableDataCell scope="col">
                                {this.state.reportData.total_coords ? this.state.reportData.total_coords : "0"}
                            </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                            <CTableHeaderCell scope="col">No of mentors created</CTableHeaderCell>
                            <CTableDataCell scope="col">
                                {this.state.reportData.total_mentors ? this.state.reportData.total_mentors : "0"}
                            </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                            <CTableHeaderCell scope="col">No of students downloaded/ Active students</CTableHeaderCell>
                            <CTableDataCell scope="col">
                                {this.state.reportData.total_students ? this.state.reportData.total_students : "0"}
                            </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                            <CTableHeaderCell scope="col">How many questions have been done (+1)</CTableHeaderCell>
                            <CTableDataCell scope="col">
                                {this.state.reportData.total_plus ? this.state.reportData.total_plus : "0"}
                            </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                            <CTableHeaderCell scope="col">How many questions have been done (Favorited)</CTableHeaderCell>
                            <CTableDataCell scope="col">
                                {this.state.reportData.total_favourite ? this.state.reportData.total_favourite : "0"}
                            </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                            <CTableHeaderCell scope="col">How many additional answers given by Coordinator</CTableHeaderCell>
                            <CTableDataCell scope="col">
                                {this.state.reportData.total_additional ? this.state.reportData.total_additional : "0"}
                            </CTableDataCell>
                        </CTableRow>
                    </CTableBody>
                </CTable>
            </>
        );
    }
}